import { motion } from "framer-motion";
import { LogoFull, APP_NAME } from "@/components/Logo";

// Full-screen branded loader: breathing full logo + sweeping progress bar.
export default function BrandLoader({ label = "Chargement de votre studio…" }) {
  return (
    <div className="min-h-screen grid-bg flex flex-col items-center justify-center bg-background gap-8" data-testid="brand-loader" aria-busy="true" aria-label={APP_NAME}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 8 }}
        animate={{ opacity: 1, scale: [0.98, 1.03, 0.98], y: 0 }}
        transition={{ opacity: { duration: 0.5 }, y: { duration: 0.5 }, scale: { duration: 2.4, repeat: Infinity, ease: "easeInOut" } }}
        className="drop-shadow-[0_0_48px_rgba(124,58,237,0.45)]"
      >
        <LogoFull width={300} />
      </motion.div>
      <div className="w-56 h-1 rounded-full bg-muted overflow-hidden">
        <motion.div
          className="h-full w-1/3 rounded-full bg-gradient-to-r from-[#7C3AED] via-[#3B82F6] to-[#06B6D4]"
          animate={{ x: ["-100%", "300%"] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <p className="font-mono text-xs text-muted-foreground tracking-widest uppercase" data-testid="brand-loader-label">{label}</p>
    </div>
  );
}
